import axios from 'axios';
import { Brand } from 'types';
import {
  convertToFormUrlEncoded,
  getAllUserTokens,
  getUserToken,
  messages,
  setLocalStorageItem,
} from 'helpers';
import { BRAND_PROPERTIES, ENV, LocalStorageKeys } from 'commons';

async function authentication({
  email,
  password,
}: {
  email: string;
  password: string;
}): Promise<any> {
  const brands = [Brand.Anacapri, Brand.Arezzo];
  const headers = { 'Content-Type': 'application/x-www-form-urlencoded' };
  const params = {
    client_id: 'arezzo_employee',
    client_secret: 'arezzoco2014',
    grant_type: 'employee_password',
    username: email,
    password,
    site_uid: 'arezzo',
    scope: 'basic',
  };

  const response = await Promise.all(
    brands.map(async (brand) => {
      let response;

      try {
        const url = `${BRAND_PROPERTIES[brand].url[ENV]}/arezzocoocc/oauth/token`;

        const { data } = await axios.post(
          url,
          convertToFormUrlEncoded(params),
          { headers }
        );

        response = {
          brand: brand,
          success: data,
        };
      } catch (error: any) {
        const { response: responseData, message: messageError } = error;

        if (messageError === 'Network Error') {
          messages([{ errorCode: 'FRONT-RE-REQUEST_TIME_OUT' }]);
        }

        const { data } = responseData;

        response = {
          brand: brand,
          error: data,
        };
      }

      return response;
    })
  );

  const hasSuccess = response.some((data) => data.success);

  if (hasSuccess) {
    return { data: response.filter((data) => data.success) };
  }

  return { error: response.filter((data) => data.error) };
}

async function refreshToken(error: any) {
  const { brand, store, accessToken, refreshToken } = getUserToken();

  const url = `${BRAND_PROPERTIES[brand].url[ENV]}/arezzocoocc/oauth/token`;
  const headers = { 'Content-Type': 'application/x-www-form-urlencoded' };
  const params = {
    client_id: 'arezzo_employee',
    client_secret: 'arezzoco2014',
    grant_type: 'refresh_token',
    refresh_token: refreshToken,
    site_uid: 'arezzo',
  };

  try {
    const response = await axios.post(url, convertToFormUrlEncoded(params), {
      headers,
    });
    const { access_token, refresh_token } = response.data;
    const access = `${access_token}|${refresh_token}`;
    const newUserInfos = { name: store, brand, access };

    setLocalStorageItem(LocalStorageKeys.SelectedStore, newUserInfos);

    const userTokens = getAllUserTokens();

    const oldToken = `${accessToken}|${refreshToken}`;
    const storesWithNewToken = userTokens.stores.map((userStore) => {
      if (userStore.access === oldToken) {
        return {
          ...userStore,
          access,
        };
      }

      return userStore;
    });

    const userWithNewAccess = {
      ...userTokens,
      stores: storesWithNewToken,
    };

    setLocalStorageItem(LocalStorageKeys.User, userWithNewAccess);

    return response.data;
  } catch (error) {
    throw error;
  }
}

async function getWhoAmI({
  brand,
  access_token,
}: {
  brand: Brand;
  access_token: string;
}) {
  const url = `${BRAND_PROPERTIES[brand].url[ENV]}/arezzocoocc/v2/${brand}/storesale/whoami?fields=FULL`;

  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
    authorization: `Bearer ${access_token}`,
  };

  const { data } = await axios.get(url, { headers });

  return { data };
}

export const authService = {
  authentication,
  refreshToken,
  getWhoAmI,
};
